import UserApiBase from "../base/UserApiBase";

import { type OkResponse } from "@/schemas/api/ok";
import { type PaginatedResponse } from "@/schemas/api/pagination";
import { type AppUserSession } from "@/schemas/auth/session";
import {
  type CreateUserRestriction,
  type RemoveUserRestriction,
  type UserRestriction,
  type UserRestrictionCheckResponse,
  UserRestrictionType,
} from "@/schemas/user/restriction";

class RestrictionService extends UserApiBase {
  public constructor(session: AppUserSession) {
    super("/restriction", session);
  }

  public getUserRestrictions(
    type: UserRestrictionType,
  ): Promise<PaginatedResponse<UserRestriction>> {
    return this.get(`/${type}`);
  }

  public addRestriction(
    target: string,
    type: UserRestrictionType,
  ): Promise<OkResponse> {
    const payload: CreateUserRestriction = {
      target: target,
      type: type,
    };
    return this.post("/create", { ...payload });
  }

  public removeRestriction(
    target: string,
    type: UserRestrictionType,
  ): Promise<OkResponse> {
    const payload: RemoveUserRestriction = {
      target: target,
      type: type,
    };
    return this.post(`/remove`, { ...payload });
  }

  public checkRestriction(
    target: string,
    type: UserRestrictionType,
  ): Promise<UserRestrictionCheckResponse> {
    return this.get(`/check/?target=${target}&type=${type}`);
  }
}

export default RestrictionService;
